type GAEventParams = {
    eventCategory?: string;
    eventLabel?: string;
    eventAction?: string;
    eventName?: string;
};
  
export const logGoogleTagsEvents = (eventName:any, eventLabel:any = '') => {
    console.log(eventName, "eventName");
    console.log(eventLabel, "eventLabel");
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, {
        event_category: 'DGR FORM',
        event_label: eventLabel,
        });
    } else {
            console.warn('gtag not defined');
    } 
};
  